import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

// Styles
import styles from './FilterItem.module.css';

// Utils
import cn from '../../../utils/cn';

// Components
import Picto from '../../atoms/Picto/Picto';

/**
 *
 * @param {object} props
 * @param {number | string} props.id
 * @param {boolean} [props.isDisabled = false]
 * @param {React.ReactNode | null} [props.children = null]
 * @param {React.ReactNode | null} [props.action = null]
 * @returns {JSX.Element} The FilterItem component
 */
function FilterItem({
  id, isDisabled = false, children = null, action = null,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    disabled: isDisabled,
  });

  return (
    <button
      type="button"
      key={id}
      className={cn([
        styles.item,
        isDisabled && styles['item-disabled'],
      ])}
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
        zIndex: isDragging ? 2 : 'auto',
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...attributes}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...listeners}
    >
      <div className={styles['item-info']}>
        <div className={styles['item-info-left']}>
          {!isDisabled ? (
            <Picto
              icon="drag-horizontal"
              className={styles['dnd-icon']}
            />
          ) : null}
          <div className={styles['item-name']}>
            {children || null}
          </div>
        </div>
        <div className={styles['item-action']}>
          {action || null}
        </div>
      </div>
    </button>
  );
}

export default FilterItem;
